<ion-header class="ion-no-border">

  <ion-toolbar>
    <ion-buttons slot="start">
      <ion-button (click)="close()">
        <fa-icon [icon]="['far', 'times']" size="lg" [fixedWidth]="true" slot="start"></fa-icon>
      </ion-button>
    </ion-buttons>
    <ion-title>{{ receipt_printer ? 'Receipt printer' : 'Searching for printers ...' }}</ion-title>
    <ion-buttons slot="end">
      @if (receipt_printer) {
        <ion-button (click)="close()">
          <fa-icon [icon]="['far', 'check']" size="lg" [fixedWidth]="true" slot="start"></fa-icon>
        </ion-button>
      }
      @if (!receipt_printer) {
        <ion-button>
          <fa-icon [icon]="['fal', 'spinner-third']" size="lg" animation="spin"></fa-icon>
        </ion-button>
      }
    </ion-buttons>
  </ion-toolbar>

</ion-header>

<ion-content class="ion-text-center">

  @if (receipt_printer) {
    <ion-list lines="full">
      <ion-item>
        <ion-label>
          <h3>{{ receipt_printer['model'] || 'Receipt printer' }}</h3>
          <p>{{ brandLabels[receipt_printer['brand']] }} &middot; {{ receipt_printer['port'] }}</p>
        </ion-label>
        <ion-button fill="clear" color="danger" slot="end" (click)="removePrinter()">
          <fa-icon [icon]="['far', 'trash']" size="lg" [fixedWidth]="true"></fa-icon>
        </ion-button>
      </ion-item>
    </ion-list>
  }

  @if (!receipt_printer) {
    @if (search_error) {
      <ion-grid class="nothing-found">
        <ion-row class="ion-align-items-center ion-justify-content-center">
          <ion-col>
            <p>
              <fa-icon [icon]="['fal', 'empty-set']" size="6x"></fa-icon>
              <span>{{ search_error }}</span>
            </p>
          </ion-col>
        </ion-row>
      </ion-grid>
    }
    @if (!search_error && printers.length === 0) {
      <ion-grid class="nothing-found">
        <ion-row class="ion-align-items-center ion-justify-content-center">
          <ion-col>
            <p>
              <fa-icon [icon]="['fal', 'empty-set']" size="6x"></fa-icon>
              <span>No printers found yet</span>
            </p>
          </ion-col>
        </ion-row>
      </ion-grid>
    }
    @if (printers && printers.length != 0) {
      <ion-list>
        @for (printer of printers; track printer; let i = $index) {
          <ion-item lines="full" button="true" (click)="select(i)">
            <ion-label>
              <h3>{{printer.modelName}}</h3>
              <p>{{ brandLabels[printer.brand] }} &middot; {{printer.portName}}</p>
            </ion-label>
          </ion-item>
        }
      </ion-list>
    }
  }

</ion-content>

@if (receipt_printer) {
  <ion-footer class="ion-no-border">
    <ion-list>
      <ion-item button="true" lines="none" detail="false" color="success" class="ion-text-center" (click)="testPrint()">
        <ion-label>TEST PRINTER</ion-label>
      </ion-item>
    </ion-list>
  </ion-footer>
}

@if (!receipt_printer) {
  <ion-footer class="ion-no-border">
    <div class="ion-text-center ion-padding" style="opacity: 0.6; font-size: 0.85em;">Star Micronics and Epson printers are supported. Epson printers must be connected via LAN or USB - Bluetooth isn't supported yet.</div>
  </ion-footer>
}
